import type { SalesByTimeBandRow, TimeBand } from '../../sales/public-api';
import type {
  PersonalPaymentMixRow,
  PersonalTopProductRow,
} from './reportsPersonalTypes';

const TIME_BAND_KEYS: TimeBand[] = ['morning', 'afternoon', 'night'];

function isTimeBand(v: string): v is TimeBand {
  return (TIME_BAND_KEYS as string[]).includes(v);
}

export function mapPersonalPaymentMixFromRpc(raw: unknown): PersonalPaymentMixRow[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      const r = row as Record<string, unknown>;
      const total = Number(r.total ?? 0);
      const sharePct = Number(r.share_pct ?? r.sharePct ?? 0);
      const methodId = String(r.method_id ?? r.methodId ?? '');
      if (!methodId || total <= 0) return null;
      return { methodId, total, sharePct };
    })
    .filter((x): x is PersonalPaymentMixRow => x != null);
}

export function mapPersonalTimeBandsFromRpc(raw: unknown): SalesByTimeBandRow[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      const r = row as Record<string, unknown>;
      const bandRaw = String(r.band ?? '');
      if (!isTimeBand(bandRaw)) return null;
      return {
        band: bandRaw,
        label: String(r.label ?? bandRaw),
        count: Number(r.count ?? 0),
        total: Number(r.total ?? 0),
      };
    })
    .filter((x): x is SalesByTimeBandRow => x != null);
}

export function mapPersonalTopProductsFromRpc(raw: unknown): PersonalTopProductRow[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      const r = row as Record<string, unknown>;
      const productId = String(r.product_id ?? r.productId ?? '');
      const label = String(r.label ?? productId);
      const qty = Number(r.qty ?? 0);
      const total = Number(r.total ?? 0);
      if (!productId && !label) return null;
      return { productId, label, qty, total };
    })
    .filter((x): x is PersonalTopProductRow => x != null);
}

export function defaultPersonalOperatorV12Fields() {
  return {
    marginPct: 0,
    ticketAvg30d: 0,
    ticketVs30dPct: null as number | null,
    timeBands: [] as SalesByTimeBandRow[],
    topProducts: [] as PersonalTopProductRow[],
    stockMovementCount: 0,
    shrinkageTotal: 0,
    stockNoSalesDays: 0,
    customerChargesTotal: 0,
    customerPaymentsTotal: 0,
    voidedCount: 0,
    voidedTotal: 0,
    voidedAsCashierCount: 0,
    voidedAsCashierTotal: 0,
    cashAvgDifference: 0,
    cashShortagePct: 0,
    cashAvgSessionHours: 0,
  };
}
